import { isCurrentlyUnavailable } from 'app/lib/unavailability';

export function useIsCurrentlyUnavailable(unavailability: unknown): boolean {
  return isCurrentlyUnavailable(unavailability);
}
